<template>
  <!-- <div class="select" @click="openList = !openList"> -->
  <div class="select">
    <div class="label">+{{ nowValue || placeholder }}</div>
    <ul v-show="openList">
      <li v-for="(item, index) in options" :key="index" @click="choose(item)">+{{ item.name }}</li>
    </ul>
    <i class=""></i>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    placeholder: String
  },
  model: {
    props: 'nowValue',
    event: 'click'
  },
  data() {
    return {
      openList: false,
      nowValue: ''
    };
  },

  methods: {
    choose(item) {
      this.nowValue = item.name;
      this.$emit('click', item.name);
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  text-align: left;
  width: 60px;
  margin-right: 10px;
  position: relative;
  border-right: 1px solid #ccc;
  font-size: 15px;
  ul {
    background-color: #fff;
    width: 100%;
    position: absolute;
    li {
      padding: 5px;
      border: 1px solid #eee;
    }
  }
}
</style>
